import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isValidString } from '@pineapplelab/util';
import { AuthService } from 'src/app/services/auth/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService: AuthService = inject(AuthService);
  const routeService: Router = inject(Router);

  const redirectIfNotLogged = isValidString(route.data['redirectIfNotLogged']) ? route.data['redirectIfNotLogged'] : '/auth/login';
  const isSigned = await authService.isSigned();
  if(!isSigned){
    routeService.navigateByUrl(redirectIfNotLogged);
    return false;
  }
  return true;
};

export const noAuthGuard: CanActivateFn = async (route, state) => {
  const authService: AuthService = inject(AuthService);
  const routeService: Router = inject(Router);

  const redirectIfIsLogged = isValidString(route.data['redirectIfIsLogged']) ? route.data['redirectIfIsLogged'] : '/events';
  const isSigned = await authService.isSigned();
  if(isSigned){
    routeService.navigateByUrl(redirectIfIsLogged);
    return false;
  }
  return true;
};
